import React from "react";

type SizeType = {
  width?: string;
  height?: string;
  inverted?: boolean;
};

export default function BtcIcon(props: SizeType) {
  const { width = "30px", height = "30px", inverted } = props;

  return (
    <svg
      viewBox="0 0 30 30"
      version="1.1"
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Designs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Mobile---Dashboard" transform="translate(-214.000000, -2694.000000)">
          <g id="Newly-listed" transform="translate(22.000000, 2556.000000)">
            <g id="Listing-4" transform="translate(192.000000, 131.000000)">
              <g id="BTC" transform="translate(0.000000, 7.000000)">
                <path
                  d="M29.8725821,15.0740896 C29.8725821,23.3172239 23.1903433,29.9994627 14.947209,29.9994627 C6.70407463,29.9994627 0.0218358209,23.3172239 0.0218358209,15.0740896 C0.0218358209,6.83095522 6.70407463,0.148716418 14.947209,0.148716418 C23.1903433,0.148716418 29.8725821,6.83095522 29.8725821,15.0740896"
                  id="Fill-504"
                  fill={inverted ? "#FFC246" : "#FFC246"}
                ></path>
                <path
                  d="M21.6281179,13.0358829 C21.9366979,10.9395656 20.3563946,9.80642115 18.1869842,9.0509915 L18.8883022,6.21813031 L17.1396826,5.77431539 L16.4477154,8.55051936 L15.082483,8.22001889 L15.7650992,5.43437205 L14.0538832,5 L13.3525652,7.83286119 L9.8927296,6.98300283 L9.47193878,8.83380548 C9.47193878,8.83380548 10.7436621,9.12653447 10.7156094,9.14542021 C11.1987947,9.21817727 11.5450903,9.65427527 11.5104365,10.1463645 L9.64025511,17.9461756 C9.59076675,18.1065349 9.48016357,18.2404399 9.33282298,18.3183773 C9.18548239,18.3963147 9.01349909,18.411887 8.85477892,18.3616619 C8.85477892,18.3616619 7.51759921,18.0406043 7.51759921,18.0406043 L6.66666667,20.0236072 L8.90153345,20.5901794 L10.1265023,20.911237 L9.41583334,23.7440982 L11.1270493,24.1690274 L11.8283674,21.3361662 L13.2123016,21.7327668 L12.5109836,24.565628 L14.2315505,25 L14.9422194,22.1199245 C17.8690533,22.6864967 20.0665165,22.4598678 20.9922563,19.7875354 C21.7403288,17.6345609 20.9922563,16.388102 19.4213039,15.585458 C20.644424,15.3394551 21.5503338,14.2928399 21.6281179,13.0358829 Z M17.7100879,18.5882908 C17.1770862,20.7412653 13.5863379,19.5325779 12.4268254,19.2870633 L13.3619161,15.509915 C14.4933759,15.7648725 18.2243878,16.3314448 17.6726843,18.5882908 L17.7100879,18.5882908 Z M18.2337387,13.0075543 C17.7568424,14.9622285 14.7645522,13.9518414 13.8014087,13.7252125 L14.6149377,10.2691218 C15.587432,10.5146364 18.701284,10.9678942 18.1963351,13.0075543 L18.2337387,13.0075543 Z"
                  id="Shape"
                  fill="#fff"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function BtcIconNoProps() {
  return (
    <svg
      viewBox="0 0 30 31"
      version="1.1"
      width="30px"
      height="30px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Designs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Mobile---Dashboard" transform="translate(-214.000000, -2694.000000)">
          <g id="Newly-listed" transform="translate(22.000000, 2556.000000)">
            <g id="Listing-4" transform="translate(192.000000, 131.000000)">
              <g id="BTC" transform="translate(0.000000, 7.000000)">
                <path
                  d="M29.8725821,15.0740896 C29.8725821,23.3172239 23.1903433,29.9994627 14.947209,29.9994627 C6.70407463,29.9994627 0.0218358209,23.3172239 0.0218358209,15.0740896 C0.0218358209,6.83095522 6.70407463,0.148716418 14.947209,0.148716418 C23.1903433,0.148716418 29.8725821,6.83095522 29.8725821,15.0740896"
                  id="Fill-504"
                  stroke="#fff"
                  // fill="#FFF"
                ></path>
                <path
                  d="M21.6281179,13.0358829 C21.9366979,10.9395656 20.3563946,9.80642115 18.1869842,9.0509915 L18.8883022,6.21813031 L17.1396826,5.77431539 L16.4477154,8.55051936 L15.082483,8.22001889 L15.7650992,5.43437205 L14.0538832,5 L13.3525652,7.83286119 L9.8927296,6.98300283 L9.47193878,8.83380548 C9.47193878,8.83380548 10.7436621,9.12653447 10.7156094,9.14542021 C11.1987947,9.21817727 11.5450903,9.65427527 11.5104365,10.1463645 L9.64025511,17.9461756 C9.59076675,18.1065349 9.48016357,18.2404399 9.33282298,18.3183773 C9.18548239,18.3963147 9.01349909,18.411887 8.85477892,18.3616619 C8.85477892,18.3616619 7.51759921,18.0406043 7.51759921,18.0406043 L6.66666667,20.0236072 L8.90153345,20.5901794 L10.1265023,20.911237 L9.41583334,23.7440982 L11.1270493,24.1690274 L11.8283674,21.3361662 L13.2123016,21.7327668 L12.5109836,24.565628 L14.2315505,25 L14.9422194,22.1199245 C17.8690533,22.6864967 20.0665165,22.4598678 20.9922563,19.7875354 C21.7403288,17.6345609 20.9922563,16.388102 19.4213039,15.585458 C20.644424,15.3394551 21.5503338,14.2928399 21.6281179,13.0358829 Z M17.7100879,18.5882908 C17.1770862,20.7412653 13.5863379,19.5325779 12.4268254,19.2870633 L13.3619161,15.509915 C14.4933759,15.7648725 18.2243878,16.3314448 17.6726843,18.5882908 L17.7100879,18.5882908 Z M18.2337387,13.0075543 C17.7568424,14.9622285 14.7645522,13.9518414 13.8014087,13.7252125 L14.6149377,10.2691218 C15.587432,10.5146364 18.701284,10.9678942 18.1963351,13.0075543 L18.2337387,13.0075543 Z"
                  id="Shape"
                  fill="#fff"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
